// SPDX-License-Identifier: Apache-2.0
//
// Korean messages for the layer 2 components (dist/vfunc-ui.locale.ko.js). Load it after
// vfunc-ui.js. The messages are defaults: the app's own messages still win (D-028).

import vf from './_internal/vf.js';
import ko from './locales/ko.js';

vf.i18n.add('ko', ko, { defaults: true });

export default ko;
